<template>
    <div
        :key="key"
        class="label-custom"
        :title="_value"
    >
        {{ _value }}
    </div>
</template>

<script>
export default {
  name: "LabelCustom",

  inheritAttrs: false,

  props: {
    value: {
      default: "",
      type: [String, Number]
    }
  },

  data() {
    return {
      key: `LabelCustom-${Math.random()
        .toString(36)
        .slice(2)}`
    };
  },

  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    }
  }
};
</script>

<style>
.label-custom {
  display: inline-block;
}
</style>
